<template lang="pug">
v-container.View.View--ConfirmAccount
  v-card(v-if="!loading")
    v-card-text.py-6
      .title.mb-2 Account Confermato
      v-layout(wrap)
        v-flex(xs12)
          p Il tuo account è stato confermato. Grazie!
        v-flex(xs12)
          v-btn(:to="{name: 'auth.login', params: { after: 'explore' }}" replace) Vai al login
  template(v-else)
    Loading
</template>

<script>
import User from "@/api/User";
import Loading from "@/components/Loading";

export default {
  components: { Loading },
  data: () => ({
    done: false,
    loading: true
  }),

  async mounted() {
    this.loading = true;
    this.$emit("update:title", "Conferma Account");

    const token = this.$route.query.token;
    if (!token) {
      this.$router.replace({ name: "auth.login" });
      return;
    }

    await User.confirmAccount({ token });
    this.loading = false;
  }
};
</script>
